// Swiper dots + autoplaying card videos, shared by every rail on the site.
// Guarded per element so repeated copies of the tag initialise each node once.
// Add a rail here rather than writing another copy of the sync loop.
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var RAILS = [
    {sec:'.irr-uses', rail:'.irr-uses__rail',  dot:'.irr-uses__dot', card:'.irr-uses__card'},
    {sec:'.irr-pf',   rail:'.irr-pf__rail',    dot:'.irr-pf__dot',   card:'.irr-pf__card'},
    {sec:'.irr-rv',   rail:'.irr-rv__shots',   dot:'.irr-rv__dot',   card:'.irr-rv__shot'},
    // The product gallery. Scoped to .irr-pdp__view, NOT .irr-pdp: the page
    // renders one view per size and only one is visible at a time, so
    // scoping to the section would hand this loop the first view's rail and
    // both views' dots at once.
    //
    // `jump` is the desktop thumbnail strip -- see initDots.
    {sec:'.irr-pdp__view', rail:'.irr-pdp__rail', dot:'.irr-pdp__dot', card:'.irr-pdp__slide', jump:'.irr-pdp__thumb'}
  ];

  function initDots(){
    RAILS.forEach(function(cfg){
      document.querySelectorAll(cfg.sec).forEach(function(s){
        if(s.dataset.railInit)return;
        var rail=s.querySelector(cfg.rail),
            dots=s.querySelectorAll(cfg.dot),
            cards=s.querySelectorAll(cfg.card);
        if(!rail||dots.length<2||cards.length!==dots.length)return;
        // Optional SECOND indicator that is also a control: the product
        // page's desktop thumbnails. Lit by the same sync as the dots -- do
        // not write a separate loop for it -- and clicking one scrolls the
        // rail to that slide. Ignored unless there is exactly one per card,
        // for the same reason the dots are.
        var jumps=cfg.jump?s.querySelectorAll(cfg.jump):[];
        if(jumps.length!==cards.length)jumps=[];
        s.dataset.railInit='1';
        // Nearest card to the rail's padded edge. Index-by-width arithmetic
        // drifts, because snapping includes the start padding and the last
        // card can never scroll far enough to reach its own index.
        function sync(){
          var edge=rail.getBoundingClientRect().left+parseFloat(getComputedStyle(rail).paddingLeft||0),
              best=0,bestD=Infinity;
          cards.forEach(function(c,n){
            var d=Math.abs(c.getBoundingClientRect().left-edge);
            if(d<bestD){bestD=d;best=n;}
          });
          dots.forEach(function(d,n){d.classList.toggle('is-on',n===best);});
          jumps.forEach(function(j,n){j.classList.toggle('is-on',n===best);});
        }
        rail.addEventListener('scroll',sync,{passive:true});
        window.addEventListener('resize',sync,{passive:true});
        jumps.forEach(function(j,n){
          j.addEventListener('click',function(){
            var c=cards[n];
            if(!c)return;
            // A DELTA, not offsetLeft: these slides' offsetParent is the
            // sticky gallery, not the rail, so offsetLeft is not a scroll
            // position. The glide itself is CSS scroll-behavior on the rail.
            rail.scrollLeft += c.getBoundingClientRect().left - rail.getBoundingClientRect().left;
            sync();
          });
        });
        // The browser pane does not fire scroll on overflow containers, so the
        // observer is what actually keeps these in sync during testing.
        if('IntersectionObserver' in window){
          var io=new IntersectionObserver(sync,{root:rail,threshold:[0,.25,.5,.75,1]});
          cards.forEach(function(c){io.observe(c);});
        }
        sync();
      });
    });
  }

  function initVideos(){
    document.querySelectorAll('.irr-uses__card--video').forEach(function(card){
      if(card.dataset.vidInit)return;
      var v=card.querySelector('video');
      if(!v)return;
      card.dataset.vidInit='1';
      var btn=card.querySelector('.irr-uses__pause');
      var held=reduce;
      function play(){var p=v.play();if(p&&p.catch)p.catch(function(){});}
      if(reduce){v.removeAttribute('autoplay');v.pause();if(btn)btn.classList.add('is-paused');}
      if(btn){
        btn.addEventListener('click',function(e){
          e.preventDefault();e.stopPropagation();
          if(v.paused){held=false;play();btn.classList.remove('is-paused');btn.setAttribute('aria-label','Pause video');}
          else{held=true;v.pause();btn.classList.add('is-paused');btn.setAttribute('aria-label','Play video');}
        });
      }
      // Only the clips actually on screen play, so five cards never decode at once.
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(entries){
          entries.forEach(function(e){
            if(e.isIntersecting){ if(!held) play(); }
            else { v.pause(); }
          });
        },{threshold:0.25}).observe(card);
      }
    });
  }

  function init(){initDots();initVideos();}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  document.addEventListener('shopify:section:load',init);
})();
